import { ILineInfo } from "@/domain/entities/lineInfo";
import { IResultData } from "@/domain/entities/shared/result";
import { useLineStore } from "@/stores/lineStore";
import {
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  ShowLoadingImage,
} from "@/types";
import { inject, ref } from "vue";

/** 체크된 노선들의 routeId로 노선 상세 API를 호출하여 데이터 관리 */
export const useGetCheckedLineDetails = () => {
  const showLoadingImage = inject(
    PROVIDE_KEY_SHOW_LOADING_IMAGE
  ) as ShowLoadingImage;
  const removeLoadingImage = inject(
    PROVIDE_KEY_REMOVE_LOADING_IMAGE
  ) as RemoveLoadingImage;

  const result = ref<IResultData<ILineInfo[]>>();
  const lineStore = useLineStore();

  /** 선택된 노선들의 routeId를 추출하여 API 병렬 호출 */
  const fetchCheckedLineDetails = async (checkedLineIds: string[]) => {
    const lineInfoFetchers: (() => Promise<IResultData<ILineInfo>>)[] = [];

    // Promise.all로 요청할 함수를 fetchAPIs 배열에 추가
    checkedLineIds.forEach((id) => {
      const getLineInfoDetail = (lineId: string) => () =>
        lineStore.getLineInfoDetail(lineId);

      if (id) {
        lineInfoFetchers.push(getLineInfoDetail(id));
      }
    });

    showLoadingImage();

    const results: IResultData<ILineInfo>[] = await Promise.all(
      lineInfoFetchers.map((fetchLineInfo) => fetchLineInfo())
    );

    removeLoadingImage();

    const failedResult = results.filter((result) => !result.isSuccess)?.[0];

    if (failedResult) {
      const { resultCode, isSuccess, errorTime, errorMessage } = failedResult;

      result.value = {
        isSuccess,
        resultCode,
        errorTime,
        errorMessage,
      };
    } else {
      result.value = {
        isSuccess: true,
        data: results.map((result) => result.data as ILineInfo),
      };
    }
  };

  return {
    result,
    fetchCheckedLineDetails,
  };
};
